// extracted by mini-css-extract-plugin
module.exports = {"qaBanner":"styles_qaBanner__25y0t","qaHeader":"styles_qaHeader__2_9ju","close":"styles_close__5d0JT"};